import { Link } from "react-router-dom";
import PageLayout from "@/components/aoria/PageLayout";
import Seo from "@/components/aoria/Seo";

/**
 * Page 404 — affichée pour toutes les URL inexistantes (catch-all React Router).
 * Conserve l'identité du site : Navigation + Footer, palette inchangée,
 * typographie cohérente. Aucune blague, aucun visuel marketing ; un message
 * sobre, des liens utiles vers le contenu existant.
 */
export default function NotFound() {
    return (
        <PageLayout testid="not-found-page">
            <Seo
                title="Page introuvable · Aoria"
                description="Cette page n'existe pas ou n'est plus disponible. Revenir à l'accueil d'Aoria ou consulter les ressources publiées."
                path="/404"
            />
            <article className="max-w-3xl mx-auto px-6 md:px-12 lg:px-20 pb-24 md:pb-32 text-center">
                <span className="editorial-num text-4xl md:text-5xl">404</span>
                <h1 className="h1 mt-8 text-4xl md:text-5xl lg:text-6xl text-[#0D1B2A] leading-[1.05]">
                    Cette page n'existe pas, ou plus.
                </h1>
                <p className="mt-8 text-[#5C6B7D] text-base md:text-lg leading-relaxed max-w-xl mx-auto">
                    L'adresse que vous avez suivie ne correspond à aucune page
                    publiée par Aoria. Le contenu a peut-être été déplacé, ou
                    l'URL contient une erreur de saisie.
                </p>

                <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/"
                        data-testid="not-found-cta-home"
                        className="btn-primary px-7 py-3 text-sm tracking-[0.15em] uppercase"
                    >
                        Retour à l'accueil
                    </Link>
                    <Link
                        to="/#ressources"
                        data-testid="not-found-cta-resources"
                        className="btn-secondary px-7 py-3 text-sm tracking-[0.15em] uppercase"
                    >
                        Voir les ressources
                    </Link>
                </div>

                <nav
                    data-testid="not-found-quick-links"
                    aria-label="Liens utiles"
                    className="mt-20 pt-10 border-t border-[#E0E1DD] grid grid-cols-1 sm:grid-cols-3 gap-3 text-left"
                >
                    <Link
                        to="/a-propos"
                        className="border border-[#E0E1DD] hover:border-[#0D1B2A] transition-colors px-5 py-4"
                    >
                        <span className="eyebrow">À propos</span>
                        <div className="mt-2 font-serif text-lg text-[#0D1B2A]">
                            L'origine du projet
                        </div>
                    </Link>
                    <Link
                        to="/#manifeste"
                        className="border border-[#E0E1DD] hover:border-[#0D1B2A] transition-colors px-5 py-4"
                    >
                        <span className="eyebrow">Manifeste</span>
                        <div className="mt-2 font-serif text-lg text-[#0D1B2A]">
                            Six articles fondateurs
                        </div>
                    </Link>
                    <Link
                        to="/#participer"
                        className="border border-[#E0E1DD] hover:border-[#0D1B2A] transition-colors px-5 py-4"
                    >
                        <span className="eyebrow">Participer</span>
                        <div className="mt-2 font-serif text-lg text-[#0D1B2A]">
                            Lettre d'information
                        </div>
                    </Link>
                </nav>
            </article>
        </PageLayout>
    );
}
